/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";

import IosSwitchMain from "../../components/iosSwitchMain";

import AddTagsModal from "../../Modals/addTagModal";

const TagTable = () => {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const rows = [
    {
      id: 1,
      name: "Indian",
    },
    {
      id: 2,
      name: "South",
    },
      {
      id: 2,
      name: "Chinese",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 2,
      minWidth: 50,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
    },

    {
      field: "name",
      headerName: "Tag Name",
      flex: 2,
      minWidth: 150,
      sortable: false,
      editable: false,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1} className="cursor_p">
          <span>{params.row.name}</span>
    
        </Box>
      ),
    },

    {
      flex: 2,
      minWidth: 150,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: () => {
        return <IosSwitchMain />;
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton onClick={() => setOpen(true)}>
                <img src="/static/images/edit_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>

      <AddTagsModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default TagTable;
